import { ICategory } from 'api/types/_category';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import TooltipCustom from 'components/Common/TooltipCustom';
import { useRole } from 'components/Hooks/UserHooks';
import RangeDatePicker from 'components/pickers/RangeDatePicker';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { COLORS_GENNERATE_NEWS, COLORS_KEYWORD_TYPE, COLORS_RANK_NEWS, KEYWORD_TYPE_OPTIONS, NEWS_CREATE_TASK_GROUP_OPTIONS, RANK_NEWS_OPTIONS, STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS, STATUS_USER_OPTIONS } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import NestingFilter from 'pages/News/Components/NestingFilter';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../components/Common/TableContainer";
import { downloadExcelKeywordTask, getAllCategory, getKeywordTasks as onGetKeywordTasks, setKeywordTaskGenerateArticleMulti } from "../../store/thunks";
export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'click_sum';

registerLocale('en', en);
registerLocale('ko', ko);


const KeywordTask = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const STATUS_USER_OPTIONS_LANG: any = STATUS_USER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const RANK_NEWS_OPTIONS_LANG = RANK_NEWS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const NEWS_CREATE_TASK_GROUP_OPTIONS_LANG = NEWS_CREATE_TASK_GROUP_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS_LANG = STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const KEYWORD_TYPE_OPTIONS_LANG = KEYWORD_TYPE_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const AFFILIATE_RANK_TYPE_OPTIONS_LANG = [{ label: 'Include', value: '1' }, { label: 'Exclude', value: '2' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const AFFILIATE_MEDIA_TYPE_OPTIONS_LANG = [{ label: 'Include', value: '1' }, { label: 'Exclude', value: '0' }]?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));


  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 50),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    keyword: withDefault(StringParam, ''),
    media_name: withDefault(StringParam, ''),
    pa_index_start: withDefault(StringParam, ''),
    pa_index_end: withDefault(StringParam, ''),
    affiliate_rank_start: withDefault(StringParam, ''),
    affiliate_rank_end: withDefault(StringParam, ''),
    start_daily_search_volume: withDefault(StringParam, ''),
    end_daily_search_volume: withDefault(StringParam, ''),
    news_section_rank_start: withDefault(StringParam, ''),
    news_section_rank_end: withDefault(StringParam, ''),
    approved_article_count_start: withDefault(StringParam, ''),
    approved_article_count_end: withDefault(StringParam, ''),
    click_sum_start: withDefault(StringParam, ''),
    click_sum_end: withDefault(StringParam, ''),
    last_published_at_start: withDefault(StringParam, ''),
    last_published_at_end: withDefault(StringParam, ''),
    exposure_rank_type: withDefault(StringParam, ''),
    type: withDefault(StringParam, ''),
    keyword_publish_log_type: withDefault(StringParam, ''),
    category_id: withDefault(StringParam, ''),
    task_group: withDefault(StringParam, ''),
    is_generated: withDefault(StringParam, ''),
  });

  const [isLoadingExportFile, setIsLoadingExportFile] = useState<boolean>(false);

  const [listCategory, setListCategory] = useState<ICategory[]>([]);

  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [groupSearch, setGroupSearch] = useState<Option | null>(NEWS_CREATE_TASK_GROUP_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.task_group)) || null);

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");
  const [mediaSearch, setMediaSearch] = useState<string>(query?.media_name || "");
  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_USER_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.status)) || null);

  const [generateSearch, setGenerateSearch] = useState<Option | null>(STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.is_generated)) || null);

  const [affiliateRankSearch, setAffiliateRankSearch] = useState<Option | null>(AFFILIATE_RANK_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.keyword_publish_log_type)) || null);

  const [affiliateMediaSearch, setAffiliateMediaSearch] = useState<Option | null>(AFFILIATE_MEDIA_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.affiliate_media)) || null);

  const [typeSearch, setTypeSearch] = useState<Option | null>(KEYWORD_TYPE_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.type)) || null);

  const [rankSearch, setRankSearch] = useState<Option | null>(RANK_NEWS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.exposure_rank_type)) || null);

  const [startPAIndexSearch, setStartPAIndexSearch] = useState<string>(query?.pa_index_start || "");
  const [endPAIndexSearch, setEndPAIndexSearch] = useState<string>(query?.pa_index_end || "");

  const [startExposureSearch, setStartExposureSearch] = useState<string>(query?.start_exposure_rank || "");
  const [endExposureSearch, setEndExposureSearch] = useState<string>(query?.end_exposure_rank || "");

  const [startAffiliateSearch, setStartAffiliateSearch] = useState<string>(query?.affiliate_rank_start || "");
  const [endAffiliateSearch, setEndAffiliateSearch] = useState<string>(query?.affiliate_rank_end || "");

  const [startLastPublishedSearch, setStartLastPublishedSearch] = useState<string>(query?.last_published_at_start || "");
  const [endLastPublishedSearch, setEndLastPublishedSearch] = useState<string>(query?.last_published_at_end || "");

  const [startDailyVolumeSearch, setStartDailyVolumeSearch] = useState<string>(query?.start_daily_search_volume || "");
  const [endDailyVolumeSearch, setEndDailyVolumeSearch] = useState<string>(query?.end_daily_search_volume || "");

  const [startNewsSectionSearch, setStartNewsSectionSearch] = useState<string>(query?.news_section_rank_start || "");
  const [endNewsSectionSearch, setEndNewsSectionSearch] = useState<string>(query?.news_section_rank_end || "");

  const [startArticleCountSearch, setStartArticleCountSearch] = useState<string>(query?.approved_article_count_start || "");
  const [endArticleCountSearch, setEndArticleCountSearch] = useState<string>(query?.approved_article_count_end || "");

  const [startClickCountSearch, setStartClickCountSearch] = useState<string>(query?.click_sum_start || "");
  const [endClickCountSearch, setEndClickCountSearch] = useState<string>(query?.click_sum_end || "");

  const [dateSearch, setDateSearch] = useState<any>(query?.date ? moment(query?.date, 'Y-MM-DD').toDate() : null);

  const [isOpenSetGenerateArticle, setIsOpenSetGenerateArticle] = useState<boolean>(false);

  const [optionsSelected, setOptionsSelected] = useState<any>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Keyword;

  const KeywordProperties = createSelector(
    selectLayoutState,
    (state) => ({
      keywordTasks: state.keywordTasks,
      isKeywordTaskSuccess: state.isKeywordTaskSuccess,
      isKeywordTaskLoading: state.isKeywordTaskLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { keywordTasks, error, isKeywordTaskLoading } = useSelector(KeywordProperties);


  useEffect(() => {
    dispatch(onGetKeywordTasks(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    if (isKeywordTaskLoading) {
      return;
    }
    setOptionsSelected((prev: any) => []);
    const queryNew = {
      ...query,
      keyword: keywordSearch || '',
      media_name: mediaSearch || '',
      date: dateSearch ? moment(new Date(dateSearch)).format("Y-MM-DD") : '',
      start_exposure_rank: startExposureSearch || '',
      end_exposure_rank: endExposureSearch || '',
      affiliate_rank_start: startAffiliateSearch || '',
      affiliate_rank_end: endAffiliateSearch || '',
      start_daily_search_volume: startDailyVolumeSearch || '',
      end_daily_search_volume: endDailyVolumeSearch || '',
      news_section_rank_start: startNewsSectionSearch || '',
      news_section_rank_end: endNewsSectionSearch || '',
      approved_article_count_start: startArticleCountSearch || '',
      approved_article_count_end: endArticleCountSearch || '',
      click_sum_start: startClickCountSearch || '',
      click_sum_end: endClickCountSearch || '',
      last_published_at_start: startLastPublishedSearch || '',
      last_published_at_end: endLastPublishedSearch || '',
      pa_index_start: startPAIndexSearch || '',
      pa_index_end: endPAIndexSearch || '',
      exposure_rank_type: rankSearch?.value,
      type: typeSearch?.value,
      keyword_publish_log_type: affiliateRankSearch?.value || '',
      affiliate_media: affiliateMediaSearch?.value || '',
      status: `${statusSearch?.value}`,
      task_group: groupSearch?.value || '',
      is_generated: generateSearch?.value ?? '',
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      ...query,
      keyword: '',
      media_name: '',
      start_exposure_rank: '',
      end_exposure_rank: '',
      affiliate_rank_start: '',
      affiliate_rank_end: '',
      start_daily_search_volume: '',
      end_daily_search_volume: '',
      news_section_rank_start: '',
      news_section_rank_end: '',
      approved_article_count_start: '',
      approved_article_count_end: '',
      click_sum_start: '',
      click_sum_end: '',
      last_published_at_start: '',
      last_published_at_end: '',
      pa_index_start: '',
      pa_index_end: '',
      status: '',
      category_id: '',
      task_group: '',
      is_generated: '',
      exposure_rank_type: '',
      type: '',
      keyword_publish_log_type: '',
      affiliate_media: '',
      order_by: 'DESC',
      sort_by: TYPE_SELECT_DEFAULT,
      date: `${moment().format("Y-MM-DD")}`,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setKeywordSearch((_prev) => "");
    setMediaSearch((_prev) => "");
    setStatusSearch(null);
    setRankSearch(null);
    setTypeSearch(null);
    setGroupSearch(null);
    setGenerateSearch(null);
    setAffiliateRankSearch(null);
    setAffiliateMediaSearch(null);
    setStartExposureSearch(queryNew?.start_exposure_rank);
    setEndExposureSearch(queryNew?.end_exposure_rank);
    setStartAffiliateSearch(queryNew?.affiliate_rank_start);
    setEndAffiliateSearch(queryNew?.affiliate_rank_end);
    setStartDailyVolumeSearch(queryNew?.start_daily_search_volume);
    setEndDailyVolumeSearch(queryNew?.end_daily_search_volume);
    setStartNewsSectionSearch(queryNew?.news_section_rank_start);
    setEndNewsSectionSearch(queryNew?.news_section_rank_end);
    setStartArticleCountSearch(queryNew?.approved_article_count_start);
    setEndArticleCountSearch(queryNew?.approved_article_count_end);
    setStartClickCountSearch(queryNew?.click_sum_start);
    setEndClickCountSearch(queryNew?.click_sum_end);
    setStartLastPublishedSearch(queryNew?.last_published_at_start);
    setEndLastPublishedSearch(queryNew?.last_published_at_end);
    setStartPAIndexSearch(queryNew?.pa_index_start);
    setEndPAIndexSearch(queryNew?.pa_index_end);
    setDateSearch(moment(queryNew?.date || "", 'Y-MM-DD').toDate());
  };

  const triggerRefresh = () => {
    setQuery({
      ...query,
      time_request: + new Date(),
    });
  }

  // Begin::Set Generate Article 
  const handleConfirmSetGenerateArticle = () => {
    setIsOpenSetGenerateArticle((_prev) => true);
  };

  const handleActionSetGenerateArticle = async () => {
    if (!countRowSelected) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const ids = (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await setKeywordTaskGenerateArticleMulti({
        keyword_ids: ids,
      });
      if (response?.code === 200) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsOpenSetGenerateArticle((_prev) => false);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        setOptionsSelected((prev: any) => []);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmSetGoldenKeywordClick = () => {
    setIsOpenSetGenerateArticle((_prev) => false);
  }
  // End::Set Generate Article 

  const handleDownloadExcel = async () => {
    try {
      setIsLoadingExportFile((_prev) => true);
      const response: any = await downloadExcelKeywordTask({ ...query });
      if (response?.data) {
        setIsLoadingExportFile((_prev) => false);
        const link = document.createElement('a');
        link.href = response?.data?.url;
        link.download = 'task_keywords';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setIsLoadingExportFile((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingExportFile((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  // Begin:: handle select table 
  const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
    // if (!!isFirstLoadingPageRef.current) {
    //   return;
    // }
    const index = String(valueIndex);
    if (valueCheck?.value === 'ALL') {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (e.target.checked) {
          if (prevClone[index] === undefined) {
            prevClone[index] = [];
          }
          prevClone[index] = (keywordTasks?.list || [])?.map((item: any) => ({ value: item?.id, label: item?.id }));
          return prevClone;
        } else {
          prevClone[index] = [];
          return prevClone;
        }
      });
      return;
    }
    if (!e.target.checked) {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
        return prevClone;
      });
    } else {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = ([...prevClone[index], valueCheck]);
        return prevClone;
      });
    }
  };

  const isChecked = (valueCheck: Option) => {
    const index = String(query.page);
    return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
  };

  const isCheckedAll = (valueIndex: string) => {
    const valueIndexString = String(valueIndex);
    return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === keywordTasks?.list?.length);
  };

  const countRowSelected = useMemo(() => {
    return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
      return Number(total + (value || [])?.length);
    }, 0)
  }, [optionsSelected]);

  // End:: handle select table 

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('Key'),
        accessor: "",
        filterable: true,
        sortable: false,
        thClass: 'text-start align-middle',
        thWidth: 50,
        thComponent: () => (<>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
            <label className="form-check-label" htmlFor={`cell-check-all`}></label>
          </div>
        </>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <>
              <div className={`form-check`}>
                <input className="form-check-input" type="checkbox" name="table" checked={isChecked({ value: cell?.row?.original?.id, label: cell?.row?.original?.id })} value={cell?.row?.original?.id ?? ''} onChange={(e) => handleCheck(({ value: cell?.row?.original?.id, label: cell?.row?.original?.id }), query?.page, e)} id={`cell-check-${cell?.row?.original?.id ?? ''}`} />
                <label className="form-check-label" htmlFor={`cell-check-${cell?.row?.original?.id ?? ''}`}></label>
              </div>
            </>
          )
        },
      },
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 80,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => (
          <>
            <span style={{ minWidth: '50px' }}>{cell?.value}</span>
          </>
        ),
      },
      {
        Header: t('Type'),
        accessor: "type",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-center",
        thWidth: i18n?.language === 'en' ? 90 : 80,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div style={{ minWidth: '60px' }} className="text-center fs-16">
              <span className={`rounded-pill badge bg-${COLORS_KEYWORD_TYPE[`${cell?.value || 0}`] || 'success'}`}>
                {KEYWORD_TYPE_OPTIONS_LANG?.find((s: any) => String(s?.value) === String(cell?.value))?.label || ''}
              </span>
            </div>
          );
        }
      },
      {
        Header: t('Group'),
        accessor: "task",
        filterable: false,
        sortable: false,
        thClass: "align-middle text-center",
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div style={{ minWidth: '70px' }} className="text-center">
              {NEWS_CREATE_TASK_GROUP_OPTIONS_LANG?.find((o: any) => String(o?.value) === String(item?.task?.task_group))?.label || ''}
            </div>
          );
        }
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 180,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="d-flex justify-content-between align-items-center cursor-pointer">
              <Link
                className="flex-grow-1 nav-link hover-underline"
                target="_blank"
                to={item?.naver_search_link || ''} >
                {cell?.value}
              </Link>
              {!!item?.task?.is_generated ?
                <TooltipCustom
                  title={t("Generated")}
                  className="d-inline-block vertical-align-middle ms-1"
                  style={{ transform: 'translateY(1px)' }}
                >
                  <i className="bx bx-check-circle text-success fs-20" />
                </TooltipCustom>
                : <></>}
              {/* <i className="bx bx-circle text-info fs-20 ms-1" /> */}
            </div>
          </>)
        },
      },
      {
        Header: t('Category'),
        accessor: "category",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }} className="d-flex flex-column align-items-start gap-2">
              {(item?.categories || [])?.map((_c: any) => (
                <span className="rounded-pill badge bg-primary-subtle text-primary fs-13" key={_c?.id}>{_c?.name}</span>
              ))}
            </div>
          </>)
        },
      },
      {
        Header: t('PA Index'),
        accessor: "pa_index",
        filterable: true,
        sortable: true,
        thWidth: 120,
        thClass: 'align-middle text-end',
        description: t('Press AI Keyword Index.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '100px' }}>{cell?.value !== null ? formatNumberWithCommas(cell?.value || 0) : '-'}</div>
          </>)
        },
      },
      {
        Header: t('Daily Search Volume'),
        accessor: "daily_search_volume",
        filterable: true,
        sortable: true,
        thClass: 'text-end align-middle',
        thWidth: i18n?.language === 'en' ? 200 : 140,
        description: t("Daily search volume is based on yesterday’s data, but depending on the data situation, it may be up to 3 days old."),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="pe-info text-end" style={{ minWidth: i18n?.language === 'en' ? '170px' : '120px' }}>{formatNumberWithCommas(cell?.value)}</div>
          </>)
        },
      },
      {
        Header: t('Approved Articles'),
        accessor: "approved_article_count",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 180 : 140,
        thClass: 'align-middle text-end',
        description: t('This is the total number of approved articles within the specified period.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '120px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('Clicks'),
        accessor: "click_sum",
        filterable: true,
        sortable: true,
        thWidth: 100,
        thClass: 'align-middle text-end',
        description: t('The total number of clicks within the specified period.'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '80px' }}>{formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('News Section'),
        accessor: "news_section_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of the news section in Naver search results (as of today).'),
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: '130px' }} className="text-end pe-info">
            {item?.news_section_rank ?? '-'}
          </div>)
        },
      },
      {
        Header: t('S.M Ranking'),
        accessor: "exposure_rank",
        filterable: true,
        sortable: true,
        thWidth: 160,
        thClass: 'align-middle text-end',
        description: t('The ranking of all Naver search-affiliated media in Naver News search results. (Based on today’s data.)'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end pe-info" style={{ minWidth: '120px' }}>{(cell?.value === null) ? '-' : formatNumberWithCommas(cell?.value || 0)}</div>
          </>)
        },
      },
      {
        Header: t('Search Media'),
        accessor: "media_name",
        filterable: true,
        sortable: false,
        thClass: 'text-end align-middle',
        thWidth: i18n?.language === 'en' ? 130 : 120,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end hover-underline-primary " style={{ minWidth: i18n?.language === 'en' ? '110px' : '100px' }}>
              <Link
                className="nav-link"
                target="_blank"
                to={item?.news_link || ''} >
                {cell?.value || '-'}
              </Link>
            </div>
          </>)
        },
      },
      {
        Header: t('PA Media Ranking'),
        accessor: "affiliate_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of Press AI-affiliated media in Naver News search results. (Based on today’s data.)'),
        thWidth: i18n?.language === 'en' ? 180 : 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info">
            {cell?.value ?? '-'}
          </div>)
        },
      },
      {
        Header: t('PA Media'),
        accessor: "affiliate_media",
        filterable: true,
        sortable: false,
        thClass: 'align-middle text-end',
        thWidth: i18n?.language === 'en' ? 150 : 120,
        description: t("Press AI-affiliated media."),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-3">
            {cell?.value ?? '-'}
          </div>)
        },
      },
      {
        Header: t('Exposure Period'),
        accessor: "last_published_at",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 170 : 120,
        thClass: 'align-middle text-end',
        description: t('The last publication date among the four most recent articles in Naver News search (as of today).'),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="text-end pe-info" style={{ minWidth: i18n?.language === 'en' ? '140px' : '100px' }}>
              {item?.last_published_label || '-'}
            </div>
          )
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 130 : 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '110px' : '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 110 : 100,
        thClass: 'text-end align-middle',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: i18n?.language === 'en' ? '90px' : '80px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
    ],
    [i18n?.language, query, userPermissions, JSON.stringify(optionsSelected)]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
  }, []);

  const changeLimitPerPage = (limit: number) => {
    if (String(limit) === String(query?.limit)) {
      return;
    }
    const queryNew = {
      ...query,
      limit: limit,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setOptionsSelected((prev: any) => []);
  };

  const handleChangeDatePicker = (date: any) => {
    setDateSearch((_prev: any) => date);
  }

  const handelChangeCategory = (category_id_search: string) => {
    setOptionsSelected((prev: any) => []);
    const queryNew = {
      ...query,
      category_id: category_id_search,
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  }

  const handleCallAllOption = async () => {
    try {
      const [res1]: any = await Promise.all([getAllCategory()]);
      const list1 = res1?.data || [];
      setListCategory((_prev) => list1);
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    document.title = `${t('Keyword')} - ${t('Task Keyword')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Task Keyword')} pageTitle={t('Keyword')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                  <div className="ribbon round-shape top-info-lg" style={{ background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem' }}>{t('This data is analyzed once a day')}</div>
                  <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                    <Row className="g-4 align-items-center">
                      <div className="col-lg-4 mt-5 mt-sm-4">
                        <div>
                          <h5 className="card-title mb-0 d-flex flex-wrap">
                            <span>
                              <span className="me-2">{t('Total')}:</span>
                              {(isKeywordTaskLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywordTasks?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                            <span className="mx-2 text-muted">|</span>
                            <span>
                              <span className="me-2">{t('Total Not Generated')}<TooltipCustom
                                title={t("The number of keywords for which articles have not been generated.")}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(1px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>:</span>
                              {(isKeywordTaskLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={Number(keywordTasks?.pagination?.total || 0) - Number(keywordTasks?.pagination?.total_generated || 0)}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                            <span className="mx-2 text-muted">|</span>
                            <span>
                              <span className="me-2">{t('Total Generated')}<TooltipCustom
                                title={t("The number of keywords for which articles have been generated.")}
                                className="d-inline-block vertical-align-middle ms-1"
                                style={{ transform: 'translateY(1px)' }}
                              >
                                <i className="ri-question-line align-bottom text-secondary" ></i>
                              </TooltipCustom>:</span>
                              {(isKeywordTaskLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywordTasks?.pagination?.total_generated || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div className="col-lg-8 text-end mt-3 mt-lg-4">
                        <div className={`d-flex gap-3 flex-wrap justify-content-end padding-lg-right-info-${i18n?.language}`}>
                          {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_LIST, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={handleDownloadExcel}
                            disabled={isLoadingExportFile}
                          >
                            {isLoadingExportFile ? <Spinner size="sm" ></Spinner> : <i className="ri-download-line align-bottom"></i>}
                            <span className="ms-1">{t('Button Download Excel')}</span>
                          </button>)}
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-center mt-0">

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2 order-2 order-xxl-0' >
                          <LabelWrapper label={t('Type')} isShow={true}>
                            <DropdownStatus
                              name="type"
                              dataList={KEYWORD_TYPE_OPTIONS_LANG || []}
                              placeholder={`${t("Type")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={typeSearch || null}
                              onChangeSelect={(e: any) => setTypeSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_KEYWORD_TYPE}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2 order-2 order-xxl-0' >
                          <LabelWrapper label={t('PA Media Ranking')} isShow={true}>
                            <DropdownOption
                              name="keyword_publish_log_type"
                              dataList={AFFILIATE_RANK_TYPE_OPTIONS_LANG || []}
                              placeholder={`${t("PA Media Ranking")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={affiliateRankSearch || null}
                              onChangeSelect={(e: any) => setAffiliateRankSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2 order-2 order-xxl-0' >
                          <LabelWrapper label={t('S.M Ranking')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={RANK_NEWS_OPTIONS_LANG || []}
                              placeholder={`${t("S.M Ranking")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={rankSearch || null}
                              onChangeSelect={(e: any) => setRankSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_RANK_NEWS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2 order-2 order-xxl-0' >
                          <LabelWrapper label={t('Group')} isShow={true}>
                            <DropdownOption
                              name="group"
                              dataList={NEWS_CREATE_TASK_GROUP_OPTIONS_LANG}
                              placeholder={`${t("Group")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={groupSearch || null}
                              onChangeSelect={(e: any) => setGroupSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2 order-2 order-xxl-0' >
                          <LabelWrapper label={t('Article Generation')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={STATUS_GENERATE_NEWS_OF_KEYWORD_OPTIONS_LANG || []}
                              placeholder={`${t("Article Generation")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={generateSearch || null}
                              onChangeSelect={(e: any) => setGenerateSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_GENNERATE_NEWS}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='date-picker-wrapper-custom mt-3 mt-xxl-2 mt-3 mt-xxl-2 order-2 order-xxl-0'>
                          <LabelWrapper label={t('Date')} isShow={!!dateSearch}>
                            <RangeDatePicker
                              maxDate={moment().toDate()}
                              dateSearch={dateSearch}
                              handleChangeDatePicker={handleChangeDatePicker}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 order-3 order-xxl-0' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startDailyVolumeSearch}
                            valueTo={endDailyVolumeSearch}
                            placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                            placeholderTo={`${t('Daily Search Volume (End)')}...`}
                            labelFrom={`${t('Daily Search Volume (Start)')}`}
                            labelTo={`${t('Daily Search Volume (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartDailyVolumeSearch(val)}
                            onChangeTo={(val) => setEndDailyVolumeSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-3 order-3 order-xxl-0' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startPAIndexSearch}
                            valueTo={endPAIndexSearch}
                            placeholderFrom={`${t('PA Index (Start)')}...`}
                            placeholderTo={`${t('PA Index (End)')}...`}
                            labelFrom={`${t('PA Index (Start)')}`}
                            labelTo={`${t('PA Index (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartPAIndexSearch(val)}
                            onChangeTo={(val) => setEndPAIndexSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-3 order-3 order-xxl-0' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startArticleCountSearch}
                            valueTo={endArticleCountSearch}
                            placeholderFrom={`${t('Approved Articles (Start)')}...`}
                            placeholderTo={`${t('Approved Articles (End)')}...`}
                            labelFrom={`${t('Approved Articles (Start)')}`}
                            labelTo={`${t('Approved Articles (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartArticleCountSearch(val)}
                            onChangeTo={(val) => setEndArticleCountSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-3 order-3 order-xxl-0' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startClickCountSearch}
                            valueTo={endClickCountSearch}
                            placeholderFrom={`${t('Clicks (Start)')}...`}
                            placeholderTo={`${t('Clicks (End)')}...`}
                            labelFrom={`${t('Clicks (Start)')}`}
                            labelTo={`${t('Clicks (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartClickCountSearch(val)}
                            onChangeTo={(val) => setEndClickCountSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-3 order-3 order-xxl-0' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startLastPublishedSearch}
                            valueTo={endLastPublishedSearch}
                            placeholderFrom={`${t('Exposure Period (Start)')}...`}
                            placeholderTo={`${t('Exposure Period (End)')}...`}
                            labelFrom={`${t('Exposure Period (Start)')}`}
                            labelTo={`${t('Exposure Period (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartLastPublishedSearch(val)}
                            onChangeTo={(val) => setEndLastPublishedSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='order-3 order-xxl-0 mt-3 mt-xxl-3' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startNewsSectionSearch}
                            valueTo={endNewsSectionSearch}
                            placeholderFrom={`${t('News Section (Start)')}...`}
                            placeholderTo={`${t('News Section (End)')}...`}
                            labelFrom={`${t('News Section (Start)')}`}
                            labelTo={`${t('News Section (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartNewsSectionSearch(val)}
                            onChangeTo={(val) => setEndNewsSectionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='order-4 order-xxl-0 mt-3'>
                          <LabelWrapper label={t('Search Media')} isShow={!!mediaSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Search Media')}...`}
                              value={mediaSearch}
                              onChange={(e) => setMediaSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='order-5 order-xxl-0 mt-3 mt-xxl-3'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={12} lg={12} xl={12} xxl={6} className="order-5 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-xxl-end mt-3 mt-xxl-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 "
                              onClick={searchData}
                              disabled={isKeywordTaskLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                  </div>
                  <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                    <Col sm={12} md={12} xl={12} xxl={12} className="mb-3 mb-lg-4">
                      <div>
                        <div className="d-flex gap-2 flex-wrap">
                          <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === '' ? 'bg-primary text-white' : 'border-gray text-secondary'}`}
                            onClick={(e) => { e.preventDefault(); handelChangeCategory('') }}
                          >
                            {t('All')}
                          </button>
                          {listCategory?.map((item) => (
                            <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.category_id) === String(item?.id) ? `bg-primary text-white` : `border-gray text-secondary`}`} key={item?.id}
                              onClick={(e) => { e.preventDefault(); handelChangeCategory(`${item?.id}`) }}
                            >
                              {item?.name}
                            </button>
                          ))}
                        </div>
                      </div>
                    </Col>
                    <Col sm={12} md={12} xl={12} className="my-0 mt-2 mt-md-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                      <div>
                        {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_UPDATE, userPermissions) &&
                          <button
                            type="button"
                            className="btn btn-soft-success"
                            style={{ width: i18n?.language === 'en' ? '145px' : '90px' }}
                            disabled={countRowSelected <= 0}
                            onClick={(e) => { e.stopPropagation(); handleConfirmSetGenerateArticle() }}
                          >
                            {countRowSelected > 0 && (
                              <span
                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                style={{ transform: "translate(0%, -70%)" }}
                              >
                                {formatNumberWithCommas(countRowSelected)}
                                <span className="visually-hidden">
                                  total keywords selected
                                </span>
                              </span>
                            )}
                            {t('Button Generate Article')}
                          </button>
                        }
                      </div>
                      <div className="mt-3 mt-md-0">
                        <LabelWrapper label={t('Showcase')} isShow={true}>
                          <DropdownOption
                            name="showcase"
                            dataList={[{ label: '30', value: '30' }, { label: '50', value: '50' }, { label: '100', value: '100' }]}
                            placeholder={`${t("Showcase")}...`}
                            className={`dropdown-status-rounded z-hight-100`}
                            classNamePrefix="name-prefix"
                            style={{ width: '85px' }}
                            initialValue={{ label: `${query?.limit}`, value: `${query?.limit}` }}
                            onChangeSelect={(e: any) => {
                              changeLimitPerPage(e?.value);
                            }}
                          />
                        </LabelWrapper>
                      </div>
                    </Col>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card "
                      tableClass="align-middle sticky-table-keyword-task"
                      theadClass="table-light"
                      columns={columns}
                      data={keywordTasks?.list?.length ? keywordTasks?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={keywordTasks?.pagination?.total}
                      customPageCount={Math.ceil(Number(keywordTasks?.pagination?.total) / Number(keywordTasks?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isKeywordTaskLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <ModalConfirm
          isShowIcon={false}
          classIconButtonConfirm=''
          classButtonConfirm={'btn-soft-success'}
          header={t('Button Generate Article')}
          textButtonConfirm={t('Button Generate Article')}
          title={t("Are you sure you want to generate article?")}
          content={t("After confirming the set action, the data will be set. Do you want to proceed with the set action.")}
          isOpen={isOpenSetGenerateArticle}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmSetGoldenKeywordClick}
          onConfirm={handleActionSetGenerateArticle}
        />

        <ToastContainer closeButton={false} newestOnTop={false} className="toast---------text" pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default KeywordTask;
